import { Injectable } from '@angular/core';

import { ThfCodeEditorRegisterable } from './interfaces/thf-code-editor-registerable.interface';
import { ThfCodeEditorRegisterableOptions } from './interfaces/thf-code-editor-registerable-options.interface';

/**
 * @description
 *
 * Wrapper para registro de sintaxes customizadas para o thf-code-editor.
 *
 * Para utilizaÃ§Ã£o do serviÃ§o de idiomas **ThfCodeEditorRegister**,
 * deve-se importar o mÃ³dulo ThfCodeEditorModule mesmo jÃ¡ tendo importado
 * o mÃ³dulo ThfModule.
 * Na importaÃ§Ã£o opcionalmente pode ser invocado o mÃ©todo **forRegister** informando um objeto para configuraÃ§Ã£o.
 *
 * Exemplo de configuraÃ§Ã£o:
 * ```
 * import { ThfCodeEditorModule, ThfCodeEditorRegisterable } from '@totvs/thf-code-editor';
 *
 * const customEditor: ThfCodeEditorRegisterable = {
 *   language: 'terraform'
 *   options: {
 *     keywords: ['resource', 'provider', 'variable', 'output', 'module', 'true', 'false'],
 *     operators: ['{', '}', '(', ')', '[', ']', '?', ':'],
 *     symbols:  /[=><!~?:&|+\-*\/\^%]+/,
 *     escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
 *     tokenizer: {
 *      ...
 *     }
 *   }
 * };
 * As configuraÃ§Ãµes para o registro de uma nova sintaxe no Monaco code editor podem ser encontradas em
 * [**Monaco Editor**](https://microsoft.github.io/monaco-editor/playground.html#extending-language-services-custom-languages).
 *
 * @NgModule({
 *   declarations: [],
 *   imports: [
 *     ThfModule,
 *     ThfCodeEditorModule.forRegister(customEditor)
 *   ],
 *   bootstrap: [AppComponent]
 * })
 * ```
 */
@Injectable()
export class ThfCodeEditorRegister implements ThfCodeEditorRegisterable {

  /** Sintaxe a ser registrada. */
  language: string;

  /** OpÃ§Ãµes da sintaxe para registro no thf-code-editor */
  options: ThfCodeEditorRegisterableOptions;

}
